import { OfficesTable } from "@/components/admin/OfficesTable";

export function SettingsOfficesPage() {
  return <OfficesTable />;
}
